import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import {
  ModalRef
} from '../../components/modal/modal-ref';
import { ModalPanelComponent } from '../page/modal-panel.component';
import { FormComponent } from '../../components/form/form.component';
import { FormFooterComponent } from '../../components/form/footer/form-footer.component';
import { FormFooterEndComponent } from '../../components/form/footer/form-footer-end.component';
import { ButtonComponent } from '../../components/button/button.component';
import { ModalHeaderComponent } from '../../components/modal/components/modal-header/modal-header.component';
import { ModalHeaderTitleComponent } from '../../components/modal/components/modal-header/modal-header-title.component';
import {
  ModalHeaderButtonsComponent
} from '../../components/modal/components/modal-header/modal-header-buttons.component';
import {
  ModalHeaderCloseButtonComponent
} from '../../components/modal/components/modal-header/modal-header-close-button.component';
import { Message } from '../../domain/messages.domain';
import { MessagesService } from '../../services/messages/messages.service';
import { ModalCloseReason } from '../../components/modal/modal.domain';
import { MessagesGroupComponent } from './messages-group.component';

@Component({
  selector: 'td-wb-messages-modal',
  templateUrl: './messages-modal.component.html',
  styleUrls: ['./messages-modal.component.scss'],
  imports: [
    TranslateDirective,
    FormComponent,
    MessagesGroupComponent,
    FormFooterComponent,
    FormFooterEndComponent,
    ModalPanelComponent,
    ModalHeaderCloseButtonComponent,
    ModalHeaderButtonsComponent,
    ModalHeaderTitleComponent,
    ModalHeaderComponent,
    ButtonComponent
  ]
})
export class MessagesModalComponent implements OnInit {
  private readonly messagesService = inject(MessagesService);
  private readonly modalRef = inject<ModalRef<MessagesModalComponent>>(ModalRef);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  messages: Array<Message>;

  ngOnInit(): void {
    this.messages = this.messagesService.getCriticalOrEssentialMessages();
    this.modalRef.afterClose().subscribe((): void => {
      this.markAsRead();
      this.changeDetectorRef.markForCheck();
    });
  }

  markAsReadAndDismiss(): void {
    this.modalRef.close(ModalCloseReason.HEADER_BUTTON); // closing modal invokes markAsRead
  }

  private markAsRead(): void {
    this.messagesService.setModalMessagesRead(true);
    this.messagesService.markMessagesAsRead(this.messages, false);
  }
}
